var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ButtonBorderedKVBase, ButtonKVBase } from '@/presentation/components';
import { IconDownloadFile, IconUploadFile } from '@/presentation/components/icons';
import React, { useRef } from 'react';
import { useRecoilState } from 'recoil';
import { uploadFromCsvStudentState } from '../atoms';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import cssnames from 'classnames';
import { parseCSV, validateCsvFile } from '@/presentation/functions/file-helper';
import { LINK_STUDENTS_CSV_TEMPLATE } from '@/presentation/constants/file-templates';
import Styles from '../../styles/steps-styles.scss';
const Step0 = () => {
    var _a;
    const inputFileRef = useRef(null);
    const [{ invalidFile, fileParsedResult, fieldMap }, setState] = useRecoilState(uploadFromCsvStudentState);
    const { showCustomError, showCustomWarning } = useCustomToast({ containerId: 'ModalUploadStudents' });
    const fileOk = ((_a = fileParsedResult === null || fileParsedResult === void 0 ? void 0 : fileParsedResult.data) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const readFile = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const selectedFile = (_b = event.target.files) === null || _b === void 0 ? void 0 : _b[0];
        if (selectedFile && validateCsvFile(selectedFile)) {
            try {
                setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
                const data = yield parseCSV(selectedFile);
                setState(prev => (Object.assign(Object.assign({}, prev), { fileParsedResult: data, step0Ready: true, isLoading: false })));
            }
            catch (error) {
                showCustomError('Error', 'Something went wrong!');
            }
        }
        else {
            showCustomError('Invalid File', "File doesn't match requirements");
            setState(prev => (Object.assign(Object.assign({}, prev), { invalidFile: true })));
        }
    });
    const changeFile = () => {
        setState(prev => (Object.assign(Object.assign({}, prev), { fieldMap: Object.assign(Object.assign({}, fieldMap), { firstMapping: false }), fileParsedResult: null, step0Ready: false, isLoading: false, firstNameTableValidation: '', lastNameTableValidation: '', emailTableValidation: '' })));
    };
    const downloadTemplate = () => {
        showCustomWarning('Disclaimer', "Caution: When opening CSV files with Apple's Numbers app on macOS, an additional title row may be automatically added, potentially affecting data structure. If you are using a Mac, please make sure your default application is set to Excel.");
        window.open(LINK_STUDENTS_CSV_TEMPLATE, 'StudentsTemplate');
    };
    return (React.createElement("div", { className: Styles.step0Wrap },
        React.createElement("div", { className: cssnames({
                [Styles.leftPart]: !invalidFile,
                [Styles.leftPartError]: invalidFile && !fileOk,
                [Styles.leftPartOk]: fileOk
            }) },
            React.createElement("div", null,
                React.createElement(IconUploadFile, { color: fileOk ? '#89C900' : invalidFile ? '#EC526E' : '#00A3FF' })),
            React.createElement("div", { className: Styles.title }, fileOk ? 'File Successfully Uploaded' : 'Upload Your CSV File'),
            React.createElement("div", { className: Styles.detail }, fileOk ? fileParsedResult === null || fileParsedResult === void 0 ? void 0 : fileParsedResult.fileName : 'Supported file formats: CSV. Max file size: 10MB'),
            React.createElement("input", { type: "file", style: { display: 'none' }, ref: inputFileRef, onChange: readFile, "data-testid": "input-file-csv" }),
            fileOk ? (React.createElement(ButtonBorderedKVBase, { type: "button", onClick: changeFile, color: "#00A3FF" }, "Change File")) : (React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: () => { var _a; return (_a = inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, btnWrapClass: Styles.widthAuto }, invalidFile ? 'Change File' : 'Upload File'))),
        React.createElement("div", { className: Styles.rightPart },
            React.createElement("div", null,
                React.createElement(IconDownloadFile, { color: '#bbb' })),
            React.createElement("div", { className: Styles.title }, "Download CSV Template"),
            React.createElement("div", { className: Styles.detail }, "Sample spreadsheet"),
            React.createElement(ButtonBorderedKVBase, { type: "button", onClick: downloadTemplate, color: "#00A3FF" }, "Download Template"))));
};
export default Step0;
